import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as s from './TemplatesList.css';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { F1 } from '@client/new/helpers/types';

type TemplatesListProps = {
  urls: string[];
  onRemove?: F1<string, void>;
};

export const TemplatesList = (p: TemplatesListProps) => {
  return (
    <div className={s.templatesList}>
      {p.urls.map((url) => (
        <div key={url} className={s.card}>
          {p.onRemove && (
            <button onClick={() => p.onRemove?.(url)} className={s.cardClose}>
              <FontAwesomeIcon icon={faClose} />
            </button>
          )}
          <img src={url} alt="" />
        </div>
      ))}
    </div>
  );
};
